import { store } from "reduxStore/store";

export const sleep = (ms) => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
};

export const filterNoOp = () => true;

export const noOp = (el: any) => el;

export const getTableStyles = (data) => {
  if (data?.length > 0) {
    return "table-portal table-header-borders table-borders fd-data-table-bordered";
  }
  return "table-portal table-header-borders table-borders bottom ";
};

export const checkRouteExceptions = () => {
  const exceptions = [
    "performance_overview",
    "ask_wisdom",
    "notification_channels",
    "cost_management",
    "data_collectors",
    "integrations",
    "collector_credentials",
    "tags",
    "subscriptions",
    "sql_activity_compare",
    "api_keys",
    "what_happened",
    "planners",
    "account",
    "custom_monitoring_queries",
    "setup_wizard",
    "configuration",
  ];
  return exceptions.some((i) => window.location.pathname.includes(i));
};

export const handleOpenNewTab = ({
  path,
  filters = {},
  values = {},
  templates = null,
  dateRange = null,
}: any) => {
  const state: any = store.getState();
  const { clientId, DatePickerParams } = state.globalFilter;

  const clearFilters = {
    ...filters,
  };

  const clearValues = {
    ...values,
  };

  const params = {
    cid: clientId,
    filters: clearFilters,
    values: clearValues,
    date: dateRange ? dateRange : DatePickerParams,
    templates,
  };
  const encode = `f${btoa(JSON.stringify(params))}`;
  const _shared_page_url = `${window?.location?.origin}${path}?share=${encode}`;
  window.open(_shared_page_url, "_blank", "noopener,noreferrer");
};
